import React from "react";
import DateInput from "../fields/DateInput";
import DateTimeInput from "../fields/DateTimeInput";

const BasicInfoSection = ({ formData, setFormData }) => {
  // 생년월일로부터 나이 계산
  const calculateAge = (birthDate) => {
    if (!birthDate) return "";
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today.getFullYear() - birth.getFullYear();
    const monthDiff = today.getMonth() - birth.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birth.getDate())
    ) {
      age--;
    }
    return age;
  };

  return (
    <section className="form-section">
      <h3>1-1. 기본정보</h3>
      {/* 환자이름, 환자번호 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">환자이름</label>
          <div className="input_2col">
            <input
              type="text"
              id="pt_name"
              name="pt_name"
              value={formData.pt_name || ""}
              onChange={(e) =>
                setFormData({ ...formData, pt_name: e.target.value })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">환자번호</label>
          <div className="input_2col">
            <input
              type="text"
              id="pt_number"
              name="pt_number"
              value={formData.pt_number || ""}
              onChange={(e) =>
                setFormData({ ...formData, pt_number: e.target.value })
              }
            />
          </div>
        </div>
      </div>

      {/* 생년월일, 나이 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">생년월일</label>
          <div className="input_2col">
            <DateInput
              id="birth"
              name="birth"
              value={formData.birth || ""}
              onChange={(date) => setFormData({ ...formData, birth: date })}
            />
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">나이</label>
          <div className="input-with-unit">
            <input
              type="text"
              id="age"
              name="age"
              value={calculateAge(formData.birth)}
              readOnly
            />
            <span className="unit-text">세</span>
          </div>
        </div>
      </div>

      {/* 성별 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">성별</label>
          <div className="input_2col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                id="sex"
                name="sex"
                value="남성"
                checked={formData.sex === "남성"}
                onChange={(e) =>
                  setFormData({ ...formData, sex: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">남성</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                id="sex"
                name="sex"
                value="여성"
                checked={formData.sex === "여성"}
                onChange={(e) =>
                  setFormData({ ...formData, sex: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">여성</div>
            </label>
          </div>
        </div>
        <div className="block-2column">
          <div className="input_2col"></div>
        </div>
      </div>

      {/* 키, 몸무게 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">키</label>
          <div className="input-with-unit">
            <input
              type="text"
              id="height"
              name="height"
              value={formData.height || ""}
              onChange={(e) =>
                setFormData({ ...formData, height: e.target.value })
              }
            />
            <span className="unit-text">cm</span>
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">몸무게</label>
          <div className="input-with-unit">
            <input
              type="text"
              id="weight"
              name="weight"
              value={formData.weight || ""}
              onChange={(e) =>
                setFormData({ ...formData, weight: e.target.value })
              }
            />
            <span className="unit-text">kg</span>
          </div>
        </div>
      </div>

      {/* 허리둘레, 엉덩이둘레 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">허리 둘레</label>
          <div className="input-with-unit">
            <input
              type="text"
              id="waist_circumference"
              name="waist_circumference"
              value={formData.waist_circumference || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  waist_circumference: e.target.value,
                })
              }
            />
            <span className="unit-text">cm</span>
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">엉덩이 둘레</label>
          <div className="input-with-unit">
            <input
              type="text"
              id="hip_circumference"
              name="hip_circumference"
              value={formData.hip_circumference || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  hip_circumference: e.target.value,
                })
              }
            />
            <span className="unit-text">cm</span>
          </div>
        </div>
      </div>

      {/* 응급실 도착시각, 전원 여부 */}
      <div className="input-wrapper-2column">
        <div className="block-2column">
          <label className="item_title_2col">응급실 도착시각</label>
          <div className="input_2col">
            <DateTimeInput
              id="ED_arrival_time"
              name="ED_arrival_time"
              value={formData.ED_arrival_time || ""}
              onChange={(datetime) =>
                setFormData({ ...formData, ED_arrival_time: datetime })
              }
            />
          </div>
        </div>
        <div className="block-2column">
          <label className="item_title_2col">타 병원에서 전원 옴</label>
          <div className="input_2col">
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                id="transfer"
                name="transfer"
                value="예"
                checked={formData.transfer === "예"}
                onChange={(e) =>
                  setFormData({ ...formData, transfer: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">예</div>
            </label>
            <label className="rad-label">
              <input
                type="radio"
                className="rad-input"
                id="transfer"
                name="transfer"
                value="아니오"
                checked={formData.transfer === "아니오"}
                onChange={(e) =>
                  setFormData({ ...formData, transfer: e.target.value })
                }
              />
              <div className="rad-design"></div>
              <div className="rad-text">아니오</div>
            </label>
          </div>
        </div>
      </div>

      {/* 전원 '예' 선택 시 나타나는 추가 필드들 */}
      {formData.transfer === "예" && (
        <>
          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                전원 보낸 병원명 (transfer_hospital)
              </label>
              <div className="input_2col">
                <input
                  type="text"
                  id="transfer_hospital"
                  value={formData.transferHospital || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      transferHospital: e.target.value,
                    })
                  }
                />
              </div>
            </div>
            <div className="block-2column">
              <label className="item_title_2col">
                전원 전 심폐소생술 시행 (pre_cpr)
              </label>
              <div className="input_2col">
                <label className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="preCpr"
                    value="예"
                    checked={formData.preCpr === "예"}
                    onChange={(e) =>
                      setFormData({ ...formData, preCpr: e.target.value })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">예</div>
                </label>
                <label className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="preCpr"
                    value="아니오"
                    checked={formData.preCpr === "아니오"}
                    onChange={(e) =>
                      setFormData({ ...formData, preCpr: e.target.value })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">아니오</div>
                </label>
              </div>
            </div>
          </div>

          <div className="input-wrapper-2column">
            <div className="block-2column">
              <label className="item_title_2col">
                전원 전 제세동 시행 (pre_defibrillation)
              </label>
              <div className="input_2col">
                <label className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="preDefibrillation"
                    value="예"
                    checked={formData.preDefibrillation === "예"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        preDefibrillation: e.target.value,
                      })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">예</div>
                </label>
                <label className="rad-label">
                  <input
                    type="radio"
                    className="rad-input"
                    name="preDefibrillation"
                    value="아니오"
                    checked={formData.preDefibrillation === "아니오"}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        preDefibrillation: e.target.value,
                      })
                    }
                  />
                  <div className="rad-design"></div>
                  <div className="rad-text">아니오</div>
                </label>
              </div>
            </div>
          </div>
        </>
      )}
    </section>
  );
};

export default BasicInfoSection;
